import React, {Component} from "react";
import SearchComponentOpenData from "../../../components/open_data/beranda/SearchComponentOpenData";

export class SearchOpenData extends Component{
    render(){
        return(
            <SearchComponentOpenData />
        )
    }
}

export default SearchOpenData;